import React, { useState } from 'react';
import '../styles/blog.css';

const BlogCarousel = () => {
  const blogs = [
    {
      id: 1,
      title: "How to Register and Verify Your Account on the Mahadev App",
      image: "/blog1.webp",
      slug: 'how-to-register-and-verify-your-account-on-the-Mahadev-app', 
    },
    {
      id: 2,
      title: "Mahadev Book App: Features, Benefits, and Installation Guide",
      image: '/blog2.webp', 
    slug: 'reddy-anna-app-features-benefits-and-installation-guide',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? blogs.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === blogs.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="blog-carousel">
        {/* Sky-Blue Heading Card */}
        <div className="carousel-heading">
          <h2><span className="highlight">Mahadev Book</span> Blog</h2>
          <p>Read our blog for betting tips, tricks, and Mahadev Book Match Predictions here.</p>
        </div>

        {/* Blog Content Section */}
        <div className="carousel-content-section">
          <div className="carousel-card">
            {/* Blog Image Card */}
            <div className="carousel-image-card">
              <img src={blogs[currentIndex].image} alt={blogs[currentIndex].title} />
            </div>

            {/* Blog Content Card */}
            <div className="carousel-text-card">
              <h3>{blogs[currentIndex].title}</h3>
              <a href={`/blogs/${blogs[currentIndex].slug}`} className="read-more">
                Read More
              </a>
            </div>
          </div>

          {/* Carousel Navigation */}
          <div className="carousel-navigation">
            <button onClick={handlePrev} className="carousel-btn">←</button>
            <button onClick={handleNext} className="carousel-btn">→</button>
          </div>
        </div>
      </div>
  );
};

export default BlogCarousel;
